<tool-drawer-container [shouldShowToggleBtn]="false">
  <tool-header
    class="tool-header"
    headerTitle="Advisor Identified At-Risk Students"
    subtitle="Displays at-risk students identified by advisors"
    marginTop="30px"
  ></tool-header>

  <at-risk-student-content class="main-content"></at-risk-student-content>

  <related-links
    class="right-sidenav"
    [links]="
      toolListService.getSuccessMetricsRelatedLinkBasedOnTool(
        'Advisor Identified At-Risk Students'
      )
    "
  ></related-links>
</tool-drawer-container>
